// extracted by mini-css-extract-plugin
module.exports = {"footer":"admin-footer_footer__zXw_f"};